import React, { useRef } from "react";
import IdleTimer from "react-idle-timer";
import Cookies from "js-cookie";
import { useRouter } from "next/router";

function SessionTimeOut() {
  let userAuth = Cookies.get("token");
  let router = useRouter();

  const idleTime = useRef(null);

  const onIdle = () => {
    if (userAuth) {
        Cookies.remove('token');
        Cookies.remove('role')
        Cookies.remove('userid')
        Cookies.remove('name')
        Cookies.remove('company_id')
        Cookies.remove('email')
        Cookies.remove('NEXT_LOCALE')
        Cookies.remove('userData')
        Cookies.remove('viewed_company_id')
        Cookies.remove('exit_simulation')

        Cookies.remove('company_language')
        Cookies.remove('display_remove_legal')
        Cookies.remove('type')
        Cookies.remove('pdfname')
        Cookies.remove('pdfurl')
        Cookies.remove('report_order_id')
        Cookies.remove('_ga')
        Cookies.remove('extraUrl')
        Cookies.remove('flinks_row_id')
        Cookies.remove('plaid_row_id')
        Cookies.remove('reference_id')
        Cookies.remove("team_access_id");

        Cookies.remove('crmp_active');
        Cookies.remove('company_name');
                          
        Cookies.remove('report_is_filled');
        Cookies.remove('pricing_id');
        Cookies.remove('subject');

        Cookies.remove('admin_token');
        Cookies.remove('admin_role');
        Cookies.remove('admin_userid');
        Cookies.remove('admin_name');
        Cookies.remove('admin_email');
        Cookies.remove('admin_companyID');
        Cookies.remove('admin_userData');

        Cookies.remove('limitedAccess');
      router.push("/");
    }
  };

  return <IdleTimer ref={idleTime} timeout={21600000} onIdle={onIdle} />;
}

export default SessionTimeOut;
